module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "lg9": "",
      "xs12": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "page-fade",
      "mode": "out-in"
    }
  }, [(!_vm.loading) ? _c('v-card', {
    staticClass: "pb-3"
  }, [_c('v-layout', {
    staticClass: "pa-3  hover-show-hidden",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    staticClass: "hidden-xs-only",
    attrs: {
      "width": "224",
      "height": "126",
      "src": _vm.imgSrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden",
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "left": "0",
      "right": "0"
    }
  }, [_c('v-btn', {
    staticClass: "no-transition",
    staticStyle: {
      "opacity": "0.9"
    },
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.play(false)
      }
    }
  }, [_vm._v("\n                                    PLAY ALL\n                                ")])], 1)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "px-3"
  }, [_c('v-layout', {
    staticClass: "fill-height",
    attrs: {
      "column": ""
    }
  }, [_c('v-layout', {
    staticClass: "shrink",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('h1', {
    staticClass: "display-1 name truncate"
  }, [_vm._v("History")])])], 1), _vm._v(" "), _c('v-flex', [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "icon": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.play('shuffled')
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("shuffle")])], 1), _vm._v(" "), _c('span', [_vm._v("Play shuffled")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "id": "list-audios",
      "two-line": ""
    }
  }, [_c('v-layout', {
    staticClass: "fill-height justify-center",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "fill-height",
    attrs: {
      "md9": ""
    }
  }, [_c('v-subheader', {
    staticClass: "fill-height"
  }, [_vm._v(_vm._s(_vm.audios.length) + " Audios")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('transition-group', _vm._l((_vm.audios), function(audio, index) {
    return _c('div', {
      key: index
    }, [_c('playlist-audio', {
      attrs: {
        "audio": audio,
        "index": index,
        "editable": false
      }
    }), _vm._v(" "), (index + 1 < _vm.audios.length) ? _c('v-divider') : _vm._e()], 1)
  }))], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79e207c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PageHistory.vue
// module id = 386
// module chunks = 0